// @ts-nocheck
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    chain,
    PopulateApiParameter,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Data/Products/Handlers/LoadVariantChildren";
import {
    getLoadVariantIdForProduct,
    loadProductRequiredExpands,
    loadProductRequiredParameters,
    setLoadVariantIdForProduct,
} from "@store/Framework/Common/Utilities/loadProductHelper";
import {
    addToChainAfter,
    addToStartOfChain,
    createChainHandler,
} from "@toolkit/Modules/client-framework/HandlerCreator";

export const PopulateProps = createChainHandler("PopulateProps", chain, props => {
    const _props = props as any;
    _props.parameter = {
        ...props.parameter,
        productId: getLoadVariantIdForProduct(_props.parameter.product) || props.parameter.productId,
    };
    _props.variantTraits = _props.parameter.product?.variantTraits;
});

addToStartOfChain(chain, PopulateProps);

export const AfterPopulateApiParameter = createChainHandler("AfterPopulateApiParameter", chain, props => {
    if (getSettingsCollection(props.getState()).emserCatalogSettings.loadProductVariantAsync) {
        props.apiParameter.expand = ["properties"];
        delete props.apiParameter.includeAttributes;
    } else {
        props.apiParameter = {
            ...props.apiParameter,
            ...loadProductRequiredParameters,
            // We remove "variantTraits" from the call and inherit them from the product instead (PopulateApiResult)
            expand: loadProductRequiredExpands.filter(x => x !== "variantTraits"),
        };
    }
});

addToChainAfter(chain, PopulateApiParameter, AfterPopulateApiParameter);

export const PopulateApiResult = createChainHandler("PopulateApiResult", chain, props => {
    const _props = props as any;

    props.apiResult.products?.forEach(x => {
        setLoadVariantIdForProduct(x, props.parameter.productId);
        if (_props.variantTraits && !x.variantTraits) {
            x.variantTraits = _props.variantTraits;
        }
    });
});

addToChainAfter(chain, RequestDataFromApi, PopulateApiResult);
